<template>
  <!-- <div>
    <ARow class="content_top">
      <ACol :span="18" offset="3">
        <slot></slot>
      </ACol>
    </ARow>
  </div> -->
  <div class="content_top">
    <slot></slot>
  </div>
</template>

<script>
// import { Row, Col } from 'ant-design-vue'
export default {
  components: {
    // ARow: Row,
    // ACol: Col,
  },
}
</script>

<style lang="less" scoped>
.content_top{
  padding:0 10%;
  height:50px;
  line-height: 50px;
  background-color: rgb(34, 105, 190);
  margin-bottom:20px;
  color: #fff;
  font-size: 12px;
}
</style>